import type { SupabaseClient } from "@supabase/supabase-js";

export type IntegrationExternalLink = {
  id: string;
  provider: string;
  entity_type: string;
  local_id: string;
  external_id: string;
  external_updated_at: string | null;
  last_synced_at: string;
  metadata: Record<string, unknown>;
};

export type IntegrationOperationOutcome = {
  organizationId: string;
  provider: string;
  error: string | null;
  occurredAt?: string;
};

export type IntegrationJournalResult =
  | { ok: true; error: null }
  | { ok: false; error: string };

export async function recordIntegrationOperation(
  client: SupabaseClient,
  outcome: IntegrationOperationOutcome,
): Promise<IntegrationJournalResult> {
  const result = await client
    .from("organization_integrations")
    .update({
      last_error: outcome.error ? outcome.error.slice(0, 500) : null,
      ...(outcome.error
        ? {}
        : { last_sync_at: outcome.occurredAt || new Date().toISOString() }),
    })
    .eq("organization_id", outcome.organizationId)
    .eq("provider", outcome.provider);

  if (result.error)
    return {
      ok: false,
      error: result.error.message,
    };
  return { ok: true, error: null };
}
